import PolicyInquiry from './PolicyInquiry';
export default PolicyInquiry;
